import { render, staticRenderFns } from "./BenefitDateField.vue?vue&type=template&id=7961481c"
import script from "./BenefitDateField.vue?vue&type=script&lang=js"
export * from "./BenefitDateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports